"use client";

import { Container } from "react-bootstrap";
import {
  FaClock,
  FaExternalLinkAlt,
  FaMailBulk,
  FaPhone,
} from "react-icons/fa";
import { Pagewrapper } from "../../components";
import "./index.scss";

const Sac = (props: any) => {
  return (
    <Pagewrapper {...props}>
      <Container>
        <div className="sac-container">
          <h1 className="sac-title">SAC - Serviço de Atendimento ao Cliente</h1>

          <div className="sac-content">
            <section className="contact-section">
              <h2>Entre em contato conosco:</h2>

              <div className="contact-list">
                <div className="contact-item">
                  <FaClock className="icon" />
                  <div className="contact-info">
                    <span className="label">Horário de atendimento</span>
                    <span className="value">
                      Segunda a Sexta 08:30h às 18:00h
                    </span>
                  </div>
                </div>

                <div className="contact-item">
                  <FaMailBulk className="icon" />
                  <div className="contact-info">
                    <span className="label">E-mail</span>
                    <span className="value">
                      <a href="mailto:sac@lex.com.br?subject=Atendimento%20LEX&body=Olá,%20preciso%20de%20ajuda">
                        sac@lex.com.br
                      </a>
                    </span>
                  </div>
                </div>

                <div className="contact-item">
                  <FaPhone className="icon" />
                  <div className="contact-info">
                    <span className="label">Telefone</span>
                    <span className="value">
                      <a href="tel:+555131913033">51 3191-3033</a>
                    </span>
                  </div>
                </div>

                <div className="contact-item whatsapp-item">
                  <svg
                    className="icon"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                  <div className="contact-info">
                    <span className="label">WhatsApp</span>
                    <span className="value">
                      <a
                        href="https://web.whatsapp.com/send?phone=555131913033&text=Preciso%20de%20ajuda%20na%20Plataforma%20LEX"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        51 3191-3033
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </section>

            <section className="portal-section">
              <p>Acesse também nosso portal de atendimento:</p>
              <a
                href="https://www.lex.com.br/contato/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaExternalLinkAlt size={18} />
                www.lex.com.br/contato
              </a>
            </section>

            <section className="message-section">
              <p>Estamos aqui para facilitar sua jornada jurídica.</p>
              <p>
                Conte com a tradição, precisão e confiabilidade da LEX Editora
                para pesquisar com segurança e profundidade.
              </p>
            </section>
          </div>
        </div>
      </Container>
    </Pagewrapper>
  );
};

export default Sac;
